<template>
  <div class="package-category-editor">
    <div class="row">
      <div class="col image-container">
        <label class="label">รูป Icon</label>
        <img :src="modalImageUrl" class="thumbnail" />
        <sc-button
          :disabled="disabled"
          class="thumbnail-button"
          @click="handleClickChooseImageButton"
        >เลือกรูป Icon</sc-button>
      </div>
      <div class="col info-editor">
        <label class="label">ชื่อ</label>
        <el-input v-model="name" :disabled="disabled" class="input"></el-input>
        <label class="label">รายการ Package</label>
        <ruejai-club-package-selector
          v-model="packages"
          :disabled="disabled"
          class="input"
        ></ruejai-club-package-selector>
      </div>
    </div>
    <image-picker-modal
      v-bind="chooseImageDialog"
      @cancel="handleCancelChooseImageDialog"
      @confirm="handleConfirmChooseImageDialog"
    ></image-picker-modal>
  </div>
</template>

<script>
import { Input } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import RuejaiClubPackageSelector from "@/lib/components/RuejaiClubPackageSelector/RuejaiClubPackageSelector";

export default {
  components: {
    ScButton,
    ImagePickerModal,
    RuejaiClubPackageSelector,
    "el-input": Input
  },
  props: {
    value: { type: Object, required: true },
    iconUrl: { type: String, default: null },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      isShowModal: false,
      iconFilePreviewUrl: null
    };
  },
  computed: {
    name: {
      get() {
        return this.value.name;
      },
      set(name) {
        this.$emit("input", { ...this.value, name });
      }
    },
    packages: {
      get() {
        return this.value.packages || [];
      },
      set(packages) {
        this.$emit("input", { ...this.value, packages });
      }
    },
    modalImageUrl() {
      return (
        this.iconFilePreviewUrl ??
        this.chooseImageDialog.thumbnailUrl ??
        "https://placehold.co/300"
      );
    },
    chooseImageDialog() {
      return {
        isShow: this.isShowModal,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูป Icon",
        width: 300,
        height: 300,
        recommendWidth: 300,
        recommendHeight: 300,
        thumbnailFile: this.value.iconFile,
        thumbnailUrl: this.iconUrl
      };
    }
  },
  watch: {
    "value.iconFile": {
      immediate: true,
      handler: function watchIconFile(iconFile) {
        if (this.iconFilePreviewUrl) {
          URL.revokeObjectURL(this.iconFilePreviewUrl);
          this.iconFilePreviewUrl = null;
        }

        if (iconFile instanceof File || iconFile instanceof Blob) {
          this.iconFilePreviewUrl = URL.createObjectURL(iconFile);
        }
      }
    }
  },
  beforeDestroy() {
    if (this.iconFilePreviewUrl) {
      URL.revokeObjectURL(this.iconFilePreviewUrl);
    }
  },
  methods: {
    handleClickChooseImageButton() {
      this.isShowModal = true;
    },
    handleCancelChooseImageDialog() {
      this.isShowModal = false;
    },
    handleConfirmChooseImageDialog(file) {
      this.$emit("input", { ...this.value, iconFile: file });
      this.isShowModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.package-category-editor {
  .thumbnail-button {
    display: block;
    width: 100%;
  }
}

.image-container {
  flex: 0 0 225px;
  width: 225px;
}

.info-editor {
  max-width: calc(100% - 225px);
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;
}

.thumbnail {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}
</style>
